import { createSlice } from '@reduxjs/toolkit';
import { fetchSectors, fetchSectorsByDistrict } from '../thunks';

interface ISector {
  id: string;
  name: string;
}

interface SectorState {
  allSectors: ISector[];
  sectorsByDistrict: ISector[];
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

const initialState: SectorState = {
  allSectors: [],
  sectorsByDistrict: [],
  count: 0,
  pages: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null
};

const sectorSlice = createSlice({
  name: 'sectors',
  initialState,
  reducers: {
    resetSectors: (state) => {
      state.sectorsByDistrict = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSectors.fulfilled, (state, action) => {
        state.loading = false;
        state.allSectors = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchSectors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch sectors';
      })
      .addCase(fetchSectorsByDistrict.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSectorsByDistrict.fulfilled, (state, action) => {
        state.loading = false;
        state.sectorsByDistrict = action.payload;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchSectorsByDistrict.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch sectors by district';
      });
  }
});

export const { resetSectors } = sectorSlice.actions;
export const sectorReducer = sectorSlice.reducer;
